const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/ // Matches 127.x.x.x
    )
);

export function register(config) {
  // Allow service worker in all environments for proper testing
  if ("serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service worker. " +
              "To learn more, visit https://cra.link/PWA"
          );
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // New content is available; show the user a prompt.
              console.log("New content is available; please refresh.");

              // Always show update notification, prefer custom handler if available
              setTimeout(() => {
                if (config && config.onUpdate) {
                  config.onUpdate(registration);
                } else {
                  showUpdateNotification(registration);
                }
              }, 1000); // Delay to ensure UI is ready
            } else {
              console.log("Content is cached for offline use.");

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    });
}

function showUpdateNotification(registration) {
  // Ensure we're in a valid state to show notifications
  if (!registration || !registration.waiting) {
    console.warn(
      "Service worker update notification called but no waiting worker found"
    );
    return;
  }

  const updateConfirmed = window.confirm(
    "🔄 A new version of the app is available!\n\nWould you like to update now? (Recommended)"
  );

  if (updateConfirmed) {
    try {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });

      // Listen for controlling service worker change
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });

      // Fallback reload in case controllerchange doesn't fire
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error during service worker update:", error);
      // Force reload as fallback
      window.location.reload();
    }
  } else {
    // Show a subtle reminder that an update is available
    console.log("Update available - user chose not to update now");

    // Optional: Show a banner or notification for later
    if (window.localStorage) {
      window.localStorage.setItem("updateAvailable", "true");
    }
  }
}

// Manual update check function for testing or user-initiated updates
export function checkForUpdates() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        console.log("Manually checking for service worker updates...");
        return registration.update();
      })
      .then(() => {
        console.log("Update check completed");
      })
      .catch((error) => {
        console.error("Error checking for updates:", error);
      });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
